import { render } from "./TabWebcam.vue?vue&type=template&id=06231bb2"
import script from "./TabWebcam.vue?vue&type=script&setup=true&lang=js"
export * from "./TabWebcam.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/TabWebcam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06231bb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06231bb2', __exports__)) {
    api.reload('06231bb2', __exports__)
  }
  
  module.hot.accept("./TabWebcam.vue?vue&type=template&id=06231bb2", () => {
    api.rerender('06231bb2', render)
  })

}


export default __exports__